import { render, staticRenderFns } from "./ReviewAppointmentSummary.vue?vue&type=template&id=74cad9fe&scoped=true&"
import script from "./ReviewAppointmentSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewAppointmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAppointmentSummary.vue?vue&type=style&index=0&id=74cad9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cad9fe",
  null
  
)

export default component.exports